
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setResultModalData, showModal, showNestedModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    isLoading: false,
    isLoadingGetSigortaList: false,
    isLoadingGetSigortaAranacakNumara: false,
    isLoadingAddSigortaTeklif: false,
    isLoadingGetSigortaBanner: false,

    isError: false,
    message:null,

    sigortaList: null,
    sigortaCount: null,
    sigortaAranacakNumara:null,
    sigortaBanner: null,

    isLoadingUpdateSigortaBanner: false,

    isAddSigortaResSuccess: false,

    updateSigortaDoc: null
}



export const getSigortaTeklifleri = createAsyncThunk("sigorta/getSigortaTeklifleri", async(currentPage, thunkApi)=> {
    try {
       
        const {data} = await axiosInstance.get(`/user/SigortaTeklifleriniGetir?CurrentPage=${currentPage}`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getSigortaAranacakNumara = createAsyncThunk("sigorta/getSigortaAranacakNumara", async(_, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.get(`/user/SigortaAranacakNumara`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const updateSigortaAranacakNumara = createAsyncThunk("sigorta/updateSigortaAranacakNumara", async(sigortaNumara, thunkApi)=> {
    try {
      
        const {data} = await axiosInstance.post(`/user/SigortaAranacakNumaraGuncelle`, sigortaNumara)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const addSigortaTeklif = createAsyncThunk("sigorta/addSigortaTeklif", async(sigortaTeklif, thunkApi)=> {
    try {

        const {data} = await axiosInstance.post(`/user/SigorataTeklifiAlEkleBilgilerle`, sigortaTeklif)
        
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("sigortaTeklifAlResult"))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

export const getSigortaBanner = createAsyncThunk("sigorta/getSigortaBanner", async(_, thunkApi)=> {
    try {

        const {data} = await axiosInstance.get(`/user/GetSigortaBannerUrl`)
        
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const updateSigortaBanner = createAsyncThunk("sigorta/updateSigortaBanner", async(banner, thunkApi)=> {
    try {
        const file = new FormData();
        file.append("file", banner);

        const {data} = await axiosInstance.put(`/user/UpdateSigortaBanner`, file)
        thunkApi.dispatch(showNestedModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Sigorta görseli başarı ile güncellendi.", resultType: "success", btnText1: "Listeyi Görüntüle"}))
        
        return data
    } catch (error) {
        
        return thunkApi.rejectWithValue(error)
    }
})


export const updateSigortaItemStatus = createAsyncThunk("sigorta/updateSigortaItemStatus", async(givenData, thunkApi)=> {
    try {
     
        const {data} = await axiosInstance.post(`/user/SigorataTeklifiGuncelle`, givenData)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})




const sigortaSlice = createSlice({
    name: "sigorta",
    initialState,
    reducers: {
        setUpdateSigortaDoc: (state, acttion) => {
            state.updateSigortaDoc = acttion.payload
        }
    },
    extraReducers:(builder)=> {
        builder

        // get sigorta teklifleri
        .addCase(getSigortaTeklifleri.pending, (state)=> {
            state.isLoadingGetSigortaList = true
        })
        .addCase(getSigortaTeklifleri.fulfilled, (state, action)=> {
            state.isLoadingGetSigortaList = false
            state.sigortaList = action.payload.data.items.$values
            state.sigortaCount = parseInt(action.payload.data.count)
            
        })
        .addCase(getSigortaTeklifleri.rejected, (state, action)=> {
            state.isLoadingGetSigortaList = false
            state.isError = true
            state.message = action.payload
        })

        // get sigorta aranacak numara
        .addCase(getSigortaAranacakNumara.pending, (state)=> {
            state.isLoadingGetSigortaAranacakNumara = true
        })
        .addCase(getSigortaAranacakNumara.fulfilled, (state, action)=> {
            state.isLoadingGetSigortaAranacakNumara = false
            state.sigortaAranacakNumara = action.payload.data.phoneNumber
            
        })
        .addCase(getSigortaAranacakNumara.rejected, (state, action)=> {
            state.isLoadingGetSigortaAranacakNumara = false
            state.isError = true
            state.message = action.payload
        })

        // update sigorta aranacak numara
        .addCase(updateSigortaAranacakNumara.pending, (state)=> {
            state.isLoadingGetSigortaAranacakNumara = true
        })
        .addCase(updateSigortaAranacakNumara.fulfilled, (state, action)=> {
            state.isLoadingGetSigortaAranacakNumara = false
            state.sigortaAranacakNumara = action.payload.data.phoneNumber
            
        })
        .addCase(updateSigortaAranacakNumara.rejected, (state, action)=> {
            state.isLoadingGetSigortaAranacakNumara = false
            state.isError = true
            state.message = action.payload
        })

        // add sigorta teklif
        .addCase(addSigortaTeklif.pending, (state)=> {
            state.isLoadingAddSigortaTeklif = true
            state.isAddSigortaResSuccess = false
        })

        .addCase(addSigortaTeklif.fulfilled, (state, action)=> {
            state.isLoadingAddSigortaTeklif = false
            state.isAddSigortaResSuccess = true
            
        })
        .addCase(addSigortaTeklif.rejected, (state, action)=> {
            state.isLoadingAddSigortaTeklif = false
            state.isError = true
            state.message = action.payload
            state.isAddSigortaResSuccess = false
        })

        // get sigorta banner
        .addCase(getSigortaBanner.pending, (state)=> {
            state.isLoadingGetSigortaBanner = true
        })
        .addCase(getSigortaBanner.fulfilled, (state, action)=> {
            state.isLoadingGetSigortaBanner = false
            state.sigortaBanner = action.payload.data.bannerName
            
        })
        .addCase(getSigortaBanner.rejected, (state, action)=> {
            state.isLoadingGetSigortaBanner = false
            state.isError = true
            state.message = action.payload
        })


        // get sigorta banner
        .addCase(updateSigortaBanner.pending, (state)=> {
            state.isLoadingUpdateSigortaBanner = true
        })
        .addCase(updateSigortaBanner.fulfilled, (state, action)=> {
            state.isLoadingUpdateSigortaBanner = false
            state.sigortaBanner = action.payload.data
            state.updateSigortaDoc = null
            
        })
        .addCase(updateSigortaBanner.rejected, (state, action)=> {
            state.isLoadingUpdateSigortaBanner = false
            state.isError = true
            state.message = action.payload
        })





        // get sigorta banner
        .addCase(updateSigortaItemStatus.pending, (state)=> {
            // state.isLoadingGetSigortaBanner = true
        })
        .addCase(updateSigortaItemStatus.fulfilled, (state, action)=> {
            // state.isLoadingGetSigortaBanner = false
            const {data} = action.payload
            state.sigortaList = state.sigortaList.map(item => {
                if(data.id === item.id){
                    return data
                }
                return item
            })
            
        })
        .addCase(updateSigortaItemStatus.rejected, (state, action)=> {
            // state.isLoadingGetSigortaBanner = false
        })

        


    }
})


export const {setUpdateSigortaDoc} = sigortaSlice.actions
export default sigortaSlice.reducer